import React, { memo } from "react";
import { FaUserNinja } from "react-icons/fa";
import { Handle } from "reactflow";

import { NodeHeader } from "../../Elements/NodeHeader";
import { NodeRef } from "../../Elements/NodeRef";

export default memo(({ data, ...rest }) => {
	function nodeHeader() {
		if (data.gushChoose === "number_owner") {
			return (
				<>
					Transferir para proprietário do número <b>@whatsappassigned</b>
				</>
			);
		}
		if (data.gushOperators && data.gushChoose === "operator") {
			const operatorSelected = data.operators.find(
				(op) => op._id === data.gushOperators[0]
			);
			return (
				<>
					Transferir para atendente <b>@{operatorSelected?.name}</b>
				</>
			);
		}
		if (data.gushInternalId) {
			return (
				<>
					Transferir para atendente <b>ID: {data.gushInternalId}</b>
				</>
			);
		}
		if (data.gushSector) {
			return (
				<>
					Transferir para atendente do setor <b>@{data.gushSector}</b>
				</>
			);
		}
	}
	return (
		<>
			<NodeRef nodeRef={data.ref} />
			<Handle
				type="target"
				position="left"
				isConnectable={true}
				isConnectableStart={false}
			/>

			<NodeHeader
				data={data}
				rest={rest}
				icon={<FaUserNinja />}
				text="Transferir para atendente"
			/>

			<div className="sendMessageContent">
				<div>{nodeHeader()}</div>
			</div>
		</>
	);
});
